export default "__VITE_ASSET__BWFdyOqr__"